import React from 'react';

import { createStore, compose, applyMiddleware } from 'redux';
import { Provider as ReduxProvider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { Router as RouterProvider } from 'react-router-dom';

import { init as SentryInit } from '@sentry/browser';

import { Breakpoints } from '@01_people/ui-library';

import { I18nextProvider } from 'react-i18next';
import i18n from './locale';

import { handleTokens, checkTokensWithRedirect } from './utils/auth';
import rootReducer from './redux/reducer';
import rootSaga from './saga';
import { browserHistory } from './utils/browser-history';
import ThemeProvider from './components/layout/connected-theme-provider';

import {
  FETCH_INIT_DATA_REQUEST,
  SET_RESPONSIVE_HEADER_VIEW,
  SET_RESPONSIVE_CONTENT_VIEW,
  ENUMERATE_DEVICES_REQUEST
} from './redux/action/types';

import ContentWrapper from './components/layout/content-wrapper';
import InfoModal from './components/info-modal';
import LoadingModal from './components/loading-modal';

SentryInit({
  dsn: 'https://92556d25bb924751bfcac3a483dadf9e@sentry.io/1778866'
});
/*
 * Tokens handling
 */

// check if we are accepting tokens, otherwise redirect with no tokens
const pathname = handleTokens();
if (pathname) {
  browserHistory.push(pathname);
} else {
  // there are no tokens we are gonna redirect
  checkTokensWithRedirect();
}

// in this moment language should be always set in localstorage
i18n.changeLanguage(localStorage.getItem('current_lang'));

/*
 * Redux & Saga
 */
const sagaMiddleware = createSagaMiddleware();

/* eslint-disable no-underscore-dangle */
const composeEnhancers = process.env.REACT_APP_DEVELOP
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;
/* esling-enable no-underscore-dangle */

const appStore = createStore(
  rootReducer /* preloadedState, */,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

class App extends React.Component {
  constructor(props) {
    super(props);
    // set initial responsiveHeader property in redux
    const floatMaxMedium = parseFloat(Breakpoints.maxMedium.slice(0, -2));
    appStore.dispatch({
      type: SET_RESPONSIVE_HEADER_VIEW,
      data: window.innerWidth <= floatMaxMedium
    });

    // set initial responsiveContent property in redux
    const floatMaxSmall = parseFloat(Breakpoints.maxSmall.slice(0, -2));
    appStore.dispatch({
      type: SET_RESPONSIVE_CONTENT_VIEW,
      data: window.innerWidth <= floatMaxSmall
    });

    // Get info about device media
    // appStore.dispatch({
    //   type: SET_CAMERA_STREAM_REQUEST
    // });
    appStore.dispatch({
      type: ENUMERATE_DEVICES_REQUEST
    });

    // CustomTheme.colors = generateThemeColors(CustomTheme.colors);
  }

  componentDidMount() {
    appStore.dispatch({
      type: FETCH_INIT_DATA_REQUEST,
      data: {
        callback: () => window.location.reload(),
        text: i18n.t('actions:try_again')
      }
    });
  }

  render() {
    return (
      <I18nextProvider i18n={i18n}>
        <ReduxProvider store={appStore}>
          <RouterProvider history={browserHistory}>
            <ThemeProvider>
              <ContentWrapper />
              <InfoModal />
              <LoadingModal />
            </ThemeProvider>
          </RouterProvider>
        </ReduxProvider>
      </I18nextProvider>
    );
  }
}

export default App;
